import { useNavigate } from 'react-router-dom';
import SearchBar from '../components/common/SearchBar';

const POPULAR = ['Diabetes Type', 'Hypertension', 'Chest Pain', 'Pneumonia', 'Annual Wellness', 'COVID-19', 'Asthma'];

const Home = () => {
    const navigate = useNavigate();
    const handleSearch = (term: string) => navigate(`/search?q=${encodeURIComponent(term)}`);

    return (
        <div className="max-w-4xl mx-auto px-4 py-10">
            {/* Hero */}
            <div className="text-center mb-10">
                <h1 className="text-3xl font-bold text-gray-900 mb-2">Find Medical Codes</h1>
                <p className="text-base text-gray-400">Search 710,000+ ICD-10, HCPCS, NDC, LOINC, SNOMED &amp; RxNorm codes</p>
            </div>

            {/* Search */}
            <div className="bg-white border border-gray-100 rounded-2xl p-6 shadow-sm mb-6">
                <SearchBar onSearch={handleSearch} placeholder="Search diagnosis, condition, drug, or code..."/>
                <div className="flex items-center gap-2 mt-4 flex-wrap">
                    <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">Trending:</span>
                    {POPULAR.map(term => (
                        <button key={term} onClick={() => handleSearch(term)}
                            className="text-[11px] px-2.5 py-1 rounded-full border border-gray-200 bg-gray-50 text-gray-500 hover:border-teal-300 hover:text-teal-700 hover:bg-teal-50 transition-all">
                            {term}
                        </button>
                    ))}
                </div>
            </div>


        </div>
    );
};

export default Home;